import type { Role } from '#/domain/role/Role'
import type { RoleRepository } from '#/domain/role/RoleRepository'

export class GetRoleListUseCase {
  constructor(private readonly repository: RoleRepository) {}

  async execute(): Promise<Role[]> {
    return this.repository.findAll()
  }
}
